var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProteinOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "525px",
    height: "525px",
    viewBox: "0 0 525 525",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "protein_other") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "protein_other",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#8898AA",
    strokeWidth: 20,
    cx: 263,
    cy: 263,
    r: 240
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-energy-3646578",
    transform: "translate(148.000000, 98.000000)",
    fill: "#8898AA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.503481,1.3199649 C180.53936,3.6010655 182.543301,8.30764757 181.388168,12.7989762 L153.017651,122.997016 L235.748885,122.997016 C240.025021,122.997016 243.850396,125.651047 245.349222,129.654937 C246.847815,133.661169 245.703851,138.175458 242.477907,140.980488 L30.410664,325.483425 C26.788881,328.633974 21.465148,328.849052 17.6029904,326.000508 C13.7363814,323.151958 12.3682264,318.004209 14.3060994,313.611282 L71.2866881,184.500227 L10.2500726,184.500227 C6.12036362,184.500227 2.3933874,182.022323 0.79616208,178.21307 C-0.798544695,174.405866 0.0457531775,170.010596 2.93996997,167.066164 L164.144343,3.0635528 C167.39549,-0.24256412 172.460809,-0.954159734 176.496921,1.32699944 L176.503481,1.3199649 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProteinOther);
export default __webpack_public_path__ + "static/media/protein_other.fb8963ca46b7e46a1dd6a9329bf567a7.svg";
export { ForwardRef as ReactComponent };